import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';
import { Button } from 'fitbeat.react-native-components';
import { Text, View, StyleSheet } from 'react-native';

import { getNextBookingStep } from '../actions';
import { TextInput, FormError } from '../../ui';
import { isNameValid, minLength3, i18n, getMomentFormat } from '../../utils';
import { styles as sharedStyles } from './Styles';
import { ProcessTypes } from 'fitbeat.gym-core';
import { BookingFlowFooter } from '../components';
import Theme from '../../theme';
class Nickname extends Component {
  static getTitle = () => <></>;

  state = {
    isLoading: false,
    error: null,
  }

  onSubmit = async (values) => {
    const {
      userProfile,
      userProfileService,
      getNextBookingStep,
    } = this.props;
    try {
      this.setState({ error: null, isLoading: true });
      userProfile.nickname = values.nickname;
      const updateUserProfile = await userProfileService.updateUserProfile(userProfile);
      getNextBookingStep(updateUserProfile, ProcessTypes.Start);
    } catch (error) {
      this.setState({ error });
    } finally {
      this.setState({ isLoading: false });
    }
  }

  render() {
    const { t, handleSubmit } = this.props;
    const { isLoading, error } = this.state;

    return (
      <View style={sharedStyles.container}
        keyboardShouldPersistTaps="handled">
        <Text style={sharedStyles.heading}>{t('bookings:yourNickname')}</Text>

        <Field
          trim
          forwardRef
          name="nickname"
          component={TextInput}
          returnKeyType="done"
          autoCapitalize="sentences"
          validate={[isNameValid, minLength3]}
          placeholder={t('formFields:nicknameGymScreen')}
        />

        <View style={styles.footer}>
          <BookingFlowFooter>
            <FormError error={error} />

            <Button
              fontColor={Theme.WHITE}
              isLoading={isLoading}
              title={t('bookings:next')}
              onPress={handleSubmit(this.onSubmit)}
            />
          </BookingFlowFooter>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  footer: {
    flex: 1,
    justifyContent: 'flex-end',
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    getNextBookingStep: (userProfile, processType) => dispatch(getNextBookingStep(userProfile, processType)),
  };
};

Nickname = translate(['auth', 'formFields', 'bookings'], { wait: true })(Nickname);
Nickname = connect(null, mapDispatchToProps)(Nickname);
Nickname = reduxForm({ form: 'NicknameForm' })(Nickname);
export default Nickname;
